class DeliveryCountdown extends HTMLElement {
  connectedCallback() {
    const configElement = this.querySelector('script[type="application/json"]');

    let config;
    try {
      config = JSON.parse(configElement.textContent);
    } catch {
      this.hidden = true;
      return;
    }

    this.countdownElement = this.querySelector('[data-countdown]');
    this.dateElement = this.querySelector('[data-date]');
    this.cutoffHour = Number(config.cutoffHour);
    this.cutoffMinute = Number(config.cutoffMinute);
    this.daysOut = Number(config.daysOut);
    this.daysOutMax = Number(config.daysOutMax);

    try {
      this.nowFormatter = new Intl.DateTimeFormat('en-US', {
        timeZone: config.timezone,
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: false,
      });
    } catch {
      this.nowFormatter = null;
    }

    const valid =
      this.countdownElement &&
      this.dateElement &&
      this.nowFormatter &&
      Number.isFinite(this.cutoffHour) &&
      Number.isFinite(this.cutoffMinute) &&
      Number.isFinite(this.daysOut) &&
      Number.isFinite(this.daysOutMax);

    if (!valid) {
      this.hidden = true;
      return;
    }

    this.dateFormatter = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' });

    this.tick = this.tick.bind(this);
    this.onVisibilityChange = () => {
      if (!document.hidden) this.tick();
    };
    document.addEventListener('visibilitychange', this.onVisibilityChange);

    this.tick();
    this.interval = setInterval(this.tick, 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
  }

  nowVirtual() {
    const map = {};
    this.nowFormatter.formatToParts(new Date()).forEach((part) => (map[part.type] = part.value));

    return Date.UTC(+map.year, map.month - 1, +map.day, map.hour % 24, +map.minute, +map.second);
  }

  formatRemaining(ms) {
    const totalSeconds = Math.max(0, Math.floor(ms / 1000));
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    const pad = (value) => String(value).padStart(2, '0');

    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  }

  tick() {
    const now = this.nowVirtual();
    const today = new Date(now);

    let cutoff = Date.UTC(
      today.getUTCFullYear(),
      today.getUTCMonth(),
      today.getUTCDate(),
      this.cutoffHour,
      this.cutoffMinute
    );
    const dispatchDay = new Date(cutoff);

    if (cutoff <= now) {
      dispatchDay.setUTCDate(dispatchDay.getUTCDate() + 1);
      cutoff = dispatchDay.getTime();
    }

    const deliveryDate = new Date(dispatchDay.getTime());
    deliveryDate.setUTCDate(deliveryDate.getUTCDate() + this.daysOut);
    let dateText = this.dateFormatter.format(deliveryDate);

    if (this.daysOutMax > this.daysOut) {
      const latestDate = new Date(dispatchDay.getTime());
      latestDate.setUTCDate(latestDate.getUTCDate() + this.daysOutMax);

      if (
        deliveryDate.getUTCMonth() === latestDate.getUTCMonth() &&
        deliveryDate.getUTCFullYear() === latestDate.getUTCFullYear()
      ) {
        dateText += ` - ${latestDate.getUTCDate()}`;
      } else {
        dateText += ` - ${this.dateFormatter.format(latestDate)}`;
      }
    }

    this.countdownElement.textContent = this.formatRemaining(cutoff - now);
    this.dateElement.textContent = dateText;
    this.classList.add('is-ready');
  }
}

if (!customElements.get('hdt-delivery-countdown')) {
  customElements.define('hdt-delivery-countdown', DeliveryCountdown);
}
